import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Form as AntdForm } from 'antd';

import { AppBarCMS } from '../../../../../../components/basic/index.jsx';
import { CollapseBlock, Spinner } from '../../../../../../components/common/index.jsx';
import IngProjectsActiveStudentsCreateForm from './IngProjectsActiveStudentsCreateForm.jsx';
import {
  useGetStudentsWithoutProjectsQuery,
  useGetIngProjectsQuery,
  useCreateActiveStudentAssignmentMutation,
} from '../../../../../../redux/services/ing_projects.jsx';
import { useGetIngProjectsSettingsQuery } from '../../../../../../redux/services/ing_projects_settings.jsx';
import { routes } from '../../../../../../utils/helpers/ApiClient.jsx';
import { useToastMessages } from '../../../../../../hooks/useToastMessages.jsx';


const IngProjectsActiveStudentsCreate = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [form] = AntdForm.useForm();

  const { saveSuccess: showSaveSuccess, saveError: showSaveError } = useToastMessages();

  const { data: students, isLoading: isStudentsLoading } = useGetStudentsWithoutProjectsQuery();
  const { data: projects, isLoading: isProjectsLoading } = useGetIngProjectsQuery();
  const { data: settings, isLoading: isSettingsLoading } = useGetIngProjectsSettingsQuery();
  const [createAssignment, { isLoading: isCreating }] = useCreateActiveStudentAssignmentMutation();

  const handleSubmit = async (values) => {
    try {
      await createAssignment({
        student_id: values.student_id,
        ip_project_id: values.ip_project_id,
        study_program_id: values.study_program_id,
        year: values.year,
      }).unwrap();

      showSaveSuccess(t('Priradenie študenta bolo úspešne vytvorené'));
      navigate(routes.cmsIngPorjectsActiveStudents);
    } catch (error) {
      showSaveError(error?.data?.message || t('Chyba pri vytváraní priradeného projektu'));
    }
  };

  if (isStudentsLoading || isProjectsLoading || isSettingsLoading) {
    return <Spinner />;
  }

  return (
    <>
      <AppBarCMS
        title={t('Priradenie nového študenta na projekt')}
        backUrl={routes.cmsIngPorjectsActiveStudents}
        backUrlTooltip={t('Aktívni študenti inž. projektov')}
      />

      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <IngProjectsActiveStudentsCreateForm
            onSubmit={handleSubmit}
            form={form}
            students={students || []}
            projects={projects || []}
            isLoading={isCreating}
            defaultYear={settings?.academic_year}
          />
        </CollapseBlock>
      </div>
    </>
  );
};

export default IngProjectsActiveStudentsCreate;
